/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { NgModule } from '@angular/core';
import { DriverDetailComponent } from '@drivers/driver-detail/driver-detail.component';
import { SharedModule } from '@shared/shared.module';
import {
  DriverDeactivationConfirmationComponent
} from './driver-deactivation-confirmation/driver-deactivation-confirmation.component';
import { DriversComponent } from './drivers/drivers.component';

@NgModule({
    declarations: [
        DriversComponent,
        DriverDetailComponent,
        DriverDeactivationConfirmationComponent
    ],
    imports: [
        SharedModule,
    ],
    exports: [DriversComponent]
})
export class DriversModule { }
